import { render } from "./App.vue?vue&type=template&id=a1fb0bfe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a1fb0bfe&lang=scss"
script.render = render

export default script